export enum Direction {
  ASC,
  DESC
}
